<template lang="pug">
	div
		b-card(no-body)

			ImgLazyWthPreloader(:link="'/events-conferences/'+event.id" :img="event.image")

			b-card-body
				b-card-title(:title="event.title") {{ event.title }}
				b-card-sub-title.mb-2
					time.text-nowrap.mr-1(:datetime="startDate") {{ startDate }}
					| -
					time.text-nowrap.ml-1(:datetime="endDate") {{ endDate }}

			b-list-group(flush)
				b-list-group-item.g-between-center(v-if="event.users_can_see_dashboard.includes(account.data.id)")
					router-link(:to="`/events-conferences/${event.id}/delivery`") Стойка регистрации
					router-link(:to="`/events-conferences/${event.id}/registrations`") Список регистраций
				b-list-group-item.g-between-center
					| Докладов
					b-badge(variant='primary') {{ event.session_count }}
				// b-list-group-item.g-between-center
					| Докладчиков
					b-badge(variant='primary') {{ event.speakers.data.length }}

			transition(name="fade" mode="out-in")
				b-card-body.g-full-center(v-if="event.isFetching")
					b-spinner(variant="primary" small label="Spinning")
				div(v-else)
					b-card-body.g-v-center.text-danger(v-if="( (event.category.slug!=='conferences' && regClose(event.start_timestamp)) || event.reg_close) && !event.is_participant")
						| регистрация закрыта
					b-card-body.g-between-center.text-success(v-else-if="event.is_participant")
						router-link(:to="{name:'MeetingsEvent'}") Встречи
						router-link.g-v-center.text-success(:to="`/registrations/${event.is_participant}`") вы участвуете
							i.icon-check.ml-1
					regBtn.w-100(:_event="event" v-else :_disabled="event.isFetching")

		eventsExtraDataModal(v-if="event.extra_data.length>0" :_event="event" :_id="`ExtraDataModal-${event.id}`")
		eventsNoExtraDataModal(v-if="!event.extra_data.length>0" :_event="event" :_id="`NoExtraDataModal-${event.id}`")

</template>

<script>
	import { mapState } from 'vuex'
	import { Switch as cSwitch } from '@coreui/vue'

	import eventsExtraDataModal from "../../components/modals/eventsExtraDataModal";
	import eventsNoExtraDataModal from "../../components/modals/eventsNoExtraDataModal";
	import ImgLazyWthPreloader from '../../components/ImgLazyWthPreloader'
	import regBtn from "../../Events/regBtn";


	export default {
		name: 'EventDetail',
		props: ['event'],
		components: {
			eventsExtraDataModal,
			eventsNoExtraDataModal,
			ImgLazyWthPreloader,
			cSwitch,
			regBtn,
		},
		data: () => ({
			transition: 'slide-right',
			dateRegExp: "d mmmm yyyy",
			labelIcon: {
				dataOn: '\u2713',
				dataOff: '\u2715'
			},
		}),
		computed: {
			...mapState(['account']),

			startDate(){ return this.$options.filters.dateFormat(this.event.start_timestamp,this.dateRegExp) },
			endDate(){ return this.$options.filters.dateFormat(this.event.end_timestamp,this.dateRegExp) },
		},
		methods: {

			checkRegHash(){
				if ( window.location.hash === '#reg' && !this.event.is_participant && !this.regClose(this.event.start_timestamp) ) {
					this.takePart()
				}
			},
			regClose: timestamp => (new Date(timestamp)).getTime() <= (new Date()).getTime(),

			takePart(){
				this.event.extra_data.length>0
					? this.$bvModal.show(`ExtraDataModal-${this.event.id}`)
					: this.$bvModal.show(`NoExtraDataModal-${this.event.id}`);
			},
		},
		mounted(){
			this.checkRegHash();
		}
	}
</script>
